// Same-origin API base. The preview ingress proxies /api/* to FastAPI on whatever
// preview host the user is currently on, so relative paths are always correct.
// In production, the same path stays correct because the SPA and the API share
// the same origin (qvoltsolar.com.au + /api).
//
// Do NOT use REACT_APP_BACKEND_URL — hardcoding a host across preview hosts breaks
// cookies (different origin → SameSite/Lax/Secure cookies are not set/sent).
export const API_BASE = "/api";
